import 'css-chunksrc/client/common/filterMenu/resourceGroups/styles.scss';export default {
  "groups": "_groups_eo9cf_1",
  "row": "_row_eo9cf_5",
  "header": "_header_eo9cf_15",
  "avatar": "_avatar_eo9cf_24",
  "iconBox": "_iconBox_eo9cf_31",
  "icon": "_icon_eo9cf_31",
  "title": "_title_eo9cf_47",
  "name": "_name_eo9cf_54",
  "list": "_list_eo9cf_61"
};